import { COMMON_PAGE_LOADED } from './constants';

/**
 * Simple action run on any page load, used later on for cookie re-render
 */
export const commonPageLoaded = () => ({
  type: COMMON_PAGE_LOADED,
});
